var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phosphor icons / Money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 6.125C0.625 5.43464 1.18464 4.875 1.875 4.875H18.125C18.8154 4.875 19.375 5.43464 19.375 6.125V14.875C19.375 15.5654 18.8154 16.125 18.125 16.125H1.875C1.18464 16.125 0.625 15.5654 0.625 14.875V6.125ZM18.125 6.125H1.875V14.875H18.125V6.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.625C8.96447 8.625 8.125 9.46447 8.125 10.5C8.125 11.5355 8.96447 12.375 10 12.375C11.0355 12.375 11.875 11.5355 11.875 10.5C11.875 9.46447 11.0355 8.625 10 8.625ZM6.875 10.5C6.875 8.77411 8.27411 7.375 10 7.375C11.7259 7.375 13.125 8.77411 13.125 10.5C13.125 12.2259 11.7259 13.625 10 13.625C8.27411 13.625 6.875 12.2259 6.875 10.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2796 5.08844C13.5069 4.82867 13.9018 4.80235 14.1616 5.02965L19.1616 9.40465C19.4213 9.63195 19.4477 10.0268 19.2204 10.2866C18.9931 10.5463 18.5982 10.5727 18.3384 10.3454L13.3384 5.97037C13.0787 5.74307 13.0523 5.34822 13.2796 5.08844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2204 10.7134C19.4477 10.9732 19.4213 11.3681 19.1616 11.5954L14.1616 15.9704C13.9018 16.1977 13.5069 16.1713 13.2796 15.9116C13.0523 15.6518 13.0787 15.2569 13.3384 15.0296L18.3384 10.6546C18.5982 10.4273 18.9931 10.4537 19.2204 10.7134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72037 5.08844C6.94767 5.34822 6.92135 5.74307 6.66157 5.97037L1.66157 10.3454C1.4018 10.5727 1.00695 10.5463 0.779648 10.2866C0.552347 10.0268 0.57867 9.63195 0.838443 9.40465L5.83844 5.02965C6.09822 4.80235 6.49307 4.82867 6.72037 5.08844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.779648 10.7134C1.00695 10.4537 1.4018 10.4273 1.66157 10.6546L6.66157 15.0296C6.92135 15.2569 6.94767 15.6518 6.72037 15.9116C6.49307 16.1713 6.09822 16.1977 5.83844 15.9704L0.838443 11.5954C0.57867 11.3681 0.552347 10.9732 0.779648 10.7134Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e914110453501d6b171e6c99e7989939.svg";
export { ForwardRef as ReactComponent };